import styled from "styled-components";
import { Flex } from "../../assets/ui";

export const StyledModalBodyWrapper = styled(Flex)`
  background-color: #ffffff;
  background-image: url("/images/thanks-modal-bg.png");
  background-size: 115% 100%;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 8px;
  flex-direction: column;
  align-items: center;
`;
